<div class="artificial-container" [class.loading]="!loaded()">
  <ngx-masonry>
     <div ngxMasonryItem class="masonry-item" *ngFor="let item of items">
      <picture>
        <source [srcset]="item.srcset_fmt[0]" type="image/avif">
        <source [srcset]="item.srcset_fmt[1]" type="image/webp">
        <img [src]="item.srcset[2][0]" [srcset]="item.srcset_fmt[2]" alt="image">
      </picture>
    </div>
  </ngx-masonry>
</div>
<div class="backdrop-container"></div>
